

import { TypedTable } from "@/components/ui/table/TypedTable";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { notificacion, notificacionError } from "@/components/Alerts";
import { useQueryClient } from "@tanstack/react-query";
import { useSubPuestos, type Subpuesto } from "./ModalPuesto";
import type { Respuesta } from "@/ts/typings/clases";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { CommonFeatures } from "@/hooks/useTanstackTable";
import { useMemo } from "react";

export function TablaSubpuestos(props: { readonly idPuesto: string; }) {
	const { data, error, isPending } = useSubPuestos(props.idPuesto);

	const { columns, features } = useMemo(() => Columns(props.idPuesto), [props.idPuesto]);


	return (
		<TypedTable
			// "scrollY": "400px",
			// "scrollCollapse": true,
			className="dataTable display"
			columns={columns}
			features={features}
			data={data ?? []}

			noResultsMessage="No se encontraron pedidos"
			errorMessage="Error cargando los subpuestos"
			isLoading={isPending}
			isError={error != null}
		/>
	);
}




function Columns(idPuesto: string) {
	const columnHelper = createColumnHelper<typeof features, Subpuesto>();
	const features = tableFeatures(CommonFeatures);

	const getAcciones = (subpuesto: Subpuesto) => <AccionesSubPuesto subpuesto={subpuesto} idPuesto={idPuesto} />;

	const columns = columnHelper.columns([
		columnHelper.accessor("codigo_subpuesto", { header: "Codigo", meta: { className: "dt-center" } }),
		columnHelper.accessor("nombre", { header: "Nombre", meta: { className: "dt-center" } }),
		columnHelper.display({
			id: "acciones",
			header: "",
			cell: ({ row }) => getAcciones(row.original),
		})
	]);
	return { columns, features };
}


function AccionesSubPuesto(props: { readonly subpuesto: Subpuesto, readonly idPuesto: string; }) {
	const queryClient = useQueryClient();


	const onConfirmarEliminar = () => {
		void sendAjaxRequest<Respuesta>("POST", "/api/v1/eliminarSubpuesto", {
			"idSubpuesto": props.subpuesto.id,
		}).then((res) => {
			if (res.tipo != "success") {
				notificacionError(res.message ?? "Error eliminando el subpuesto.");
				return;
			}
			notificacion(res.message ?? "Subpuesto eliminado correctamente.");
			return queryClient.invalidateQueries({ queryKey: ["getSubpuestos", props.idPuesto] });
		});
	};
	const onEliminar = () => {
		if (window.confirm("¿Está seguro que desea eliminar este subpuesto?")) {
			onConfirmarEliminar();
		}
	};


	return (
		<div style={{ display: "flex", justifyContent: "center" }}>
			{/* <button className="icon-round youtube-bg btnIcon mostrarEditSubpuesto">
				<i className="fa fa-pen-to-square" />
			</button> */}
			<button className="main-color btnIcon" onClick={onEliminar} type="button">
				<i className="fa fa-trash" style={{ fontSize: 20 }} />
			</button>
		</div>
	);
}